module.exports = __webpack_public_path__ + "static/media/acacia-intro.fad3e358.png";